<template>
  <!--
    Komponent wyświetlający legendę statusów.
    Używany wewnątrz filtrów do objaśnienia ikon dostępności.
  -->
  <div class="filter d-flex flex-column">
    <!-- Nagłówek sekcji legendy -->
    <h5>
      {{ t('legend') }}  <!-- Tytuł legendy (przetłumaczony) -->
    </h5>

    <!-- Kontener z pozycjami legendy -->
    <div class="info collapse show" id="legend">
      <!-- Wiersz z ikoną OK i opisem -->
      <div class="row mb-2">
        <div class="col-1"></div>                       <!-- Puste miejsce dla wyrównania -->
        <div class="col-2 icons-status-ok"></div>       <!-- Ikona statusu OK -->
        <div class="col-7 p-0">{{ t('available') }}</div> <!-- Opis: dostępny -->
      </div>
      <!-- Wiersz z ikoną NOT OK i opisem -->
      <div class="row mb-2">
        <div class="col-1"></div>                         <!-- Puste miejsce -->
        <div class="col-2 icons-status-not-ok"></div>    <!-- Ikona statusu niedostępny -->
        <div class="col-7 p-0">{{ t('unavailable') }}</div> <!-- Opis: niedostępny -->
      </div>
      <!-- Przykładowe dodatkowe wiersze (zakomentowane) -->
      <!-- <div class="row mb-2">
        <div class="col-1"></div>
        <div class="col-2 icons-status-error"></div>
        <div class="col-7 p-0">Awaria</div>
      </div>
      <div class="row mb-2">
        <div class="col-1"></div>
        <div class="col-2 icons-status-on"></div>
        <div class="col-7 p-0">Włączony</div>
      </div> -->
    </div>
  </div>
</template>

<script setup>
/**
 * Korzystamy z vue-i18n do tłumaczeń tekstów.
 */
import { useI18n } from 'vue-i18n';
const { t } = useI18n();  // Funkcja tłumacząca klucze
</script>

<style scoped>
/* Styl nagłówka sekcji */
.filter h5 {
  padding: 10px 20px;
  background-color: white;
  position: relative;
  /* Tło z grafiką filtrów (po prawej powtarzająco) */
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}

/* Wysokość wierszy legendy */
.row {
  height: 30px;
  line-height: 25px;  /* Wyrównanie tekstu pionowo */
}

/* Kontener z wpisami legendy */
.info {
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;  /* Dolna ramka */
}

/* Dodatkowe style dla paragrafów wewnątrz info (jeśli użyte) */
.info p {
  font-size: 12px;
  margin: 0;
}
</style>
